import { RequestService } from '@/services/request.service'
import ServerDirections from '@/config/server-directions'
const requestService = new RequestService()

export class AuthRequests {
  login (email, password) {
    function map (data) {
      return { token: data.token }
    }
    const route = ServerDirections.LOGIN
    const method = 'post'
    const body = {
      email,
      password,
    }
    return requestService.makePromise(route, method, { body, noAuth: true }, map)
  }

  sendAccessMail (email, nextUrl) {
    const route = ServerDirections.CREDENTIALS_SEND
    const method = 'post'
    function map (data) {
      return data
    }
    const body = {
      email,
    }

    if (nextUrl) {
      body.next_url = nextUrl
    }
    return requestService.makePromise(route, method, { body, noAuth: true }, map)
  }

}
